import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMail = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.164 16-16S24.837 0 16 0"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M23 10a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm.16 2.144a.75.75 0 0 0-1.016-.304L16 15.148 9.856 11.84a.75.75 0 0 0-.712 1.32l6.5 3.5c.222.12.49.12.712 0l6.5-3.5a.75.75 0 0 0 .304-1.016"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMail);

export default ForwardRef;
